<div class="tours-skeleton-list">
  @for (card of skeletonCards; track card) {
    <div class="tours-skeleton-card">
      <div class="tours-skeleton-card__image">
        <div class="skeleton-block skeleton-image-main"></div>
      </div>

      <div class="tours-skeleton-card__content">
        <div class="tours-skeleton-card__top">
          <div class="tours-skeleton-card__meta">
            <div class="skeleton-block skeleton-meta-wide"></div>
            <div class="skeleton-block skeleton-meta-short"></div>
            <div class="skeleton-meta-lines">
              <div class="skeleton-block skeleton-meta-line skeleton-meta-line_top"></div>
              <div class="skeleton-block skeleton-meta-line skeleton-meta-line_bottom"></div>
            </div>
            <div class="skeleton-block skeleton-meta-short"></div>
            <div class="skeleton-meta-lines">
              <div class="skeleton-block skeleton-meta-line skeleton-meta-line_top"></div>
              <div class="skeleton-block skeleton-meta-line skeleton-meta-line_bottom"></div>
            </div>
          </div>
          <div class="tours-skeleton-card__rating-badges">
            <div class="skeleton-block skeleton-rating-badge"></div>
            <div class="skeleton-block skeleton-rating-badge"></div>
            <div class="skeleton-block skeleton-rating-badge"></div>
            <div class="skeleton-block skeleton-rating-badge"></div>
          </div>
        </div>

        <div class="tours-skeleton-card__title-lines">
          <div class="skeleton-block skeleton-title"></div>
          <div class="skeleton-block skeleton-subtitle"></div>
        </div>

        <div class="tours-skeleton-card__price-info">
          <div class="skeleton-block skeleton-price-caption"></div>
          <div class="skeleton-block skeleton-price-note"></div>
        </div>

        <div class="tours-skeleton-card__footer">
          <div class="tours-skeleton-card__service-row">
            <div class="skeleton-block skeleton-service"></div>
            <div class="skeleton-block skeleton-service"></div>
            <div class="skeleton-block skeleton-service"></div>
          </div>
          <div class="tours-skeleton-card__actions">
            <div class="skeleton-block skeleton-action-icon"></div>
            <div class="skeleton-block skeleton-button"></div>
          </div>
        </div>
      </div>
    </div>
  }
</div>
